// המגירה של ההשתלמות האישית יושבת במסך שנטען ב-lazy, ולכן ייתכן שהיא עדיין לא
// מורכבת ברגע שלוחצים על הכפתור במסך הראשי. האירוע מטפל במקרה הרגיל, והדגל
// pending מכסה את המקרה שבו הקומפוננטה עולה רק אחרי הלחיצה.
const EVENT_NAME = 'open-mentoring-syllabus';

let pending = false;

export const requestOpenMentoring = () => {
  pending = true;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const consumePendingOpen = () => {
  const wasPending = pending;
  pending = false;
  return wasPending;
};

export const onOpenMentoring = (handler) => {
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};
